/* eslint-disable @typescript-eslint/no-explicit-any */
/* Trainee / Intern — Benefits. Simple opt-in toggles; all default off. */
import React from "react";
import { SectionCard, ApplicableToggle } from "./_controls";

const TraineeBenefitsSection = () => (
  <SectionCard title="Benefits" subtitle="Optional benefits for the trainee. All off by default.">
    <div className="divide-y divide-slate-100 dark:divide-gray-700">
      <ApplicableToggle name="pfApplicable" label="Provident Fund" subtitle="Usually not applicable to stipends." />
      <ApplicableToggle name="esiApplicable" label="Employee State Insurance" />
      <ApplicableToggle name="insuranceApplicable" label="Medical Insurance" />
    </div>
  </SectionCard>
);

export default TraineeBenefitsSection;
